import type { SxProps, Theme } from "@mui/material/styles";

/**
 * Use on every DialogTitle so headings stay centered.
 * `textAlign` alone is not enough: MUI nests Typography and `component="span"`
 * stays shrink-wrapped unless inner text is centered explicitly.
 */
export const dialogTitleCenterSx: SxProps<Theme> = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  width: "100%",
  boxSizing: "border-box",
  "& .MuiTypography-root": {
    display: "block",
    width: "100%",
    textAlign: "center"
  }
};
